module.exports = __webpack_public_path__ + "static/img/5-3.f9e79b19.jpg";